<script>

const moment = require('moment');

export default {

    name: 'item-action-button',
    props: [ 'item' ],
    data() {
        return {
        }
    },
    computed: {
        //can_delete() { return [ 'set_qrcode_position', 'sent' ].includes( this.item.config.status ); },
        erased() { return this.$store.state.item.erased; },
        email_sent() { return this.item.config.email }
    },
    watch: {
        erased( newval, oldval ) {
            if ( newval === true && oldval === false ) {
                this.$store.dispatch( 'item/get_all', { options: { include: true }, force_reload: true } );
            }
        },
    },
    created () {
    },
    methods: {
        remove() { // TODO il backend elimina solo il record, non i file
            this.$bvModal.msgBoxConfirm('Eliminare il documento? Se il documento è stato inviato non sarà comunque possibile eliminarlo dalla catena di notarizzazione.', { buttonSize: 'sm' })
                .then( value => {
                    if ( value === true ) {
                        this.$store.dispatch('item/destroy', this.item.id);
                    }
                })
                .catch(err => {
                    // An error occurred
                })
        },
        set_sent() {
            this.$store.dispatch( 'item/set_email_sent', { email: false, id: this.item.id } );
        },
    },

}

</script>

<template>

    <div class="text-center">
        <b-button variant="danger" @click="remove" size="sm">Elimina</b-button>
        <b-button v-b-tooltip.hover :title="email_sent ? 'Permette di re-inviare la email' : 'La email non è stata inviata'" variant="warning" style="margin-left: 20px;" :disabled="email_sent === false" @click="set_sent" size="sm">Email non inviata</b-button>
    </div>

</template>


